// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { inject, observer } from "../../../../stores/mobx-compat";
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker-overrides.css';

import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Alert from '../../../ui/Alert';
import { DownloadIcon, CalendarIcon } from '../../../ui/icons';
import { planLimits } from '../../../../enums';

class Emails extends Component {
  constructor(props) {
    super(props);

    const { planStartDate } = this.props.store.auth.user;
    const currentDay = moment().date();
    const planStartDay = moment(planStartDate).date();

    const startDate = planStartDay >= currentDay
      ? moment().subtract(1, 'month').date(planStartDay).toDate()
      : moment().date(planStartDay).toDate();

    this.state = { startDate, endDate: new Date(), preset: null };
  }

  onRangeChange = ([start, end]) => {
    this.setState({ startDate: start, endDate: end, preset: null });
  }

  setPreset = (days) => {
    const end = new Date();
    const start = moment().subtract(days, 'day').toDate();
    const { planStartDate } = this.props.store.auth.user;
    const minStart = planStartDate ? moment.max(moment(start), moment(planStartDate)).toDate() : start;
    this.setState({ startDate: minStart, endDate: end, preset: days });
  }

  render() {
    const { planStartDate, planName } = this.props.store.auth.user;
    const { planObj = {} } = this.props.store.accountStatus;
    const planMeta = planObj.metadata || {};
    const { loading } = this.props.store.analytics;

    return (
      <>
        <Alert
          tone="info"
          title="Download leads data as CSV"
        >
          You may download your list of abandoned and submitted leads here. Any form field becomes
          a CSV column. By default, the range spans your last payment date to today.
        </Alert>

        <div
          className="grid gap-5 mt-5"
          style={{ gridTemplateColumns: this.props.store.ui.mobile ? '1fr' : '1.4fr 1fr' }}
        >
          <Card padded>
            <CardHead
              title="Selected date range"
              sub={`${moment(this.state.startDate).format('MM/DD/YYYY')} – ${moment(this.state.endDate).format('MM/DD/YYYY')}`}
            />
            <div className="mov-presets mb-3">
              {[7, 30, 90].map((d) => (
                <PresetChip
                  key={d}
                  label={`Last ${d} days`}
                  active={this.state.preset === d}
                  onClick={() => this.setPreset(d)}
                />
              ))}
            </div>
            <div className="mov-rangepicker">
              <DatePicker
                selectsRange
                inline
                showPopperArrow={false}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.onRangeChange}
                monthsShown={2}
                minDate={planStartDate && moment(planStartDate).toDate()}
                maxDate={new Date()}
              />
            </div>
            <Button
              variant="primary"
              icon={DownloadIcon}
              loading={loading.initiateEmailDownload}
              disabled={loading.initiateEmailDownload}
              onClick={() => this.props.store.analytics.downloadCaptures(this.state.startDate, this.state.endDate)}
              className="mt-3 w-full"
            >
              Download CSV
            </Button>
          </Card>

          <Card padded>
            <CardHead title="Plan details" icon={CalendarIcon} />
            <dl className="m-0 grid gap-2.5 text-[13px]">
              <Row k="Current plan" v={planMeta.name || planName || 'N/A'} />
              <Row k="Plan start" v={planStartDate || 'N/A'} />
              <Row k="Limit" v={planMeta.limit || planLimits[planName] || 'N/A'} />
            </dl>
          </Card>
        </div>

        <a
          ref={(ref) => { this.props.store.analytics.setEmailRef(ref); }}
          style={{ display: 'none' }}
        >Hidden CSV anchor</a>
      </>
    );
  }
}

const PresetChip = ({ label, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={!!active}
    className={`mov-preset ${active ? 'is-on' : ''}`}
  >
    {label}
  </button>
);

const Row = ({ k, v }) => (
  <div className="flex items-center justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
    <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{k}</dt>
    <dd className="m-0 font-medium">{v}</dd>
  </div>
);

export default inject('store')(observer(Emails));
